export default __webpack_public_path__ + "static/media/changePasswordPatient.fb6b6870.svg";